import { withWordpressLanguage } from 'wordpress/utils'

import { locationsSelector } from '../selectors'

import '../styles/locations.scss'
import { loadOnMount } from 'shared/hoc'
import { getOnstreetLocations } from 'on-street/actions'

const LocationsView = ({ locations }) => (
    <div className="container locations">
        <h1 className="text-center">
            <T>onstreet.locations.title</T>
        </h1>
        <h3 className="description text-center">
            <T>onstreet.locations.description</T>
        </h3>

        <div className="row location-grid">
            {locations.map((location, i) => {
                const { name, slug } = location

                return (
                    <div className="col-lg-4 col-md-6 col-sm-12 text-center" key={i}>
                        <span>
                            <Link className="btn btn-primary" to={`on-street/${slug}`} title={name}>
                                {name}
                            </Link>
                        </span>
                    </div>
                )
            })}
        </div>
    </div>
)

export default compose(
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            locations: locationsSelector,
        }),
        { getOnstreetLocations }
    ),
    loadOnMount('getOnstreetLocations')
)(LocationsView)
